export enum EQueryKeyLoadBalancer {
  GET_MINER_DETAIL = 'GET_MINER_DETAIL',
  GET_STAT_DETAIL = 'GET_STAT_DETAIL',
}

export type GetStatMinerDetailPayloads = {
  accountName: string;
  accountPassword: string;
  sortBy?: ESortMiner;
};
export type ConnectionStatMiner = {
  connected: boolean;
  switches: number;
  uri: string;
};
export type MiningInfoDetailStatMiner = {
  hashrate: string;
  pause_reason: string;
  paused: boolean;
  segment: Array<string>;
  shares: Array<number>;
};
export type DeviceInfoStatMiner = {
  _index: number;
  _mode: string;
  hardware: {
    name: string;
    pci: string;
    sensors: Array<number>;
    type: string;
  };
  mining: MiningInfoDetailStatMiner;
};

export type HostStatMiner = {
  name: string;
  runtime: number;
  version: string;
};

export type MiningInfoStatMiner = {
  difficulty: number;
  epoch: number;
  epoch_changes: number;
  hashrate: string;
  shares: Array<number>;
};

export type ResultStatMiner = {
  connection: ConnectionStatMiner;
  devices: DeviceInfoStatMiner[];
  host: HostStatMiner;
  mining: MiningInfoStatMiner;
  monitors: Object;
};

export type TJSONMinerStatDetail = {
  id: number;
  jsonrpc: string;
  result: ResultStatMiner;
};
export type TCardTypes = Array<string>;

export type TMinerDetail = {
  hostName: string;
  hostIP: string;
  privateIP: string;
  status: string;
  totalHashRate: number;
  cardTypes: string;
  cardCounts: string;
  updatedAt: number;
  statMinerKey: string;
  keyStatMinerDetail: string;
};
export type TStatMinerDetail = {
  cardType: string;
  cardCount: number;
  hashrate: number;
  avgHashRate: number;
};

export enum EStatusMiner {
  ALL = 'All',
  ONLINE = 'Online',
  OFFLINE = 'Offline',
}

export enum ESortMiner {
  ASC = 'asc',
  DESC = 'desc',
}

export type TFilterMiner = {
  status: EStatusMiner;
  sort: ESortMiner;
};
